import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.215, 0.61, 0.355, 1];

export function FadeUp({ children, delay = 0, y = 32, className = "", testid }) {
    return (
        <motion.div
            data-testid={testid}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay, ease: EASE }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "0px 0px -8% 0px" });
    return (
        <span ref={ref} className={`block overflow-hidden pb-[0.08em] ${className}`}>
            <motion.span
                className="block will-change-transform"
                initial={false}
                animate={inView ? { y: "0%" } : { y: "112%" }}
                transition={{ duration: 1.05, delay, ease: [0.16, 1, 0.3, 1] }}
            >
                {children}
            </motion.span>
        </span>
    );
}

export const staggerParent = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12 } },
};

export const staggerChild = {
    hidden: { opacity: 0, y: 28 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.7, ease: EASE },
    },
};

export function Stagger({ children, className = "", testid }) {
    return (
        <motion.div
            data-testid={testid}
            variants={staggerParent}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            className={className}
        >
            {children}
        </motion.div>
    );
}

export function StaggerItem({ children, className = "" }) {
    return (
        <motion.div variants={staggerChild} className={className}>
            {children}
        </motion.div>
    );
}
